import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TFormState} from 'src/app/models/forms.model';

type TCancelSave = 'Save' | 'Cancel';

@Component({
    selector: 'app-button-group-save-cancel',
    templateUrl: './button-group-save-cancel.component.html',
    styleUrl: './button-group-save-cancel.component.scss'
})
export class AppButtonGroupSaveCancelComponent {
    @Input() formState: TFormState
    @Input() saveLabel: string = 'WIDGETS.SAVE'
    @Output() actionEvent: EventEmitter<TCancelSave> = new EventEmitter<TCancelSave>
}